import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // 🟢 Importamos BrowserRouter
import './index.css';
import App from './App.jsx';
import AppProviders from './context/AppProviders';

// Mitiga fallos de imports dinámicos cuando hay un nuevo deploy
// y el navegador intenta cargar chunks con hash antiguo.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter> {/* 🟢 Envolvemos todo en BrowserRouter para que los Providers tengan acceso al contexto */}
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>
  </React.StrictMode>
);
